// extracted by mini-css-extract-plugin
export default {"container":"EntityRecordView_container__4BHPB","back":"EntityRecordView_back__cTIjV","wrapper":"EntityRecordView_wrapper__Jq-U8"};